import { axios } from 'lib/axios';
import { useQuery } from '@tanstack/react-query';


const getByIDRequest = async (id) => {
  try {
    return await axios.get(`/api/dps/${id}`);
  } catch (error) {
    if (error?.response?.data.description === "record not found") {
      throw new Error("Object doesn't exist");
    }
    
    throw new Error("You don't have permissions to see this object");
  }
  // return await axios.get(`/api/dps/${id}`, {headers: {"company_id": companyID}});
};

export const useGetByID = (id, config = {}) => {
  const configOptions = {select: ({ data }) => data, retry: false, ...config}
  return useQuery({
    queryKey: [`dps-${id}`],
    queryFn: () => getByIDRequest(id),
    ...configOptions
  });
};
